import { DatePipe } from '@angular/common';
import { TranslatePipe } from '../../filters/translate.pipe';
import { Component, OnInit, OnChanges, SimpleChanges, HostListener, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import Session from '../../utils/session.service';
import ChatRestServices from '../../services/chat-rest.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import Config from '../../utils/config.service';
import Toast from '../../services/toast.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import ProfilePictureService from '../../services/profile-picture.service';
import { Input } from '@angular/core';
import { StringBuilderPipe } from '../../filters/string-builder.pipe';

@Component({
	standalone: true,
	selector: 'item-message-booking-offer',
	templateUrl: './item-message-booking-offer.component.html',
	imports: [ CommonModule, DatePipe, TranslatePipe, StringBuilderPipe ]
})
export class ItemMessageBookingOfferComponent implements OnInit, OnChanges {
	private session: Session = inject(Session);
	private chatRestServices: ChatRestServices = inject(ChatRestServices);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private config: Config = inject(Config);
	private toast: Toast = inject(Toast);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private profilePictureService: ProfilePictureService = inject(ProfilePictureService);

	@Input() lastSeen: any | undefined;
	@Input() chat: any;
	@Input() group: any;

	vm: any = undefined;
	activeMessage: any | null = null;
	isDesktop = window.innerWidth >= 768;

	constructor() {
		this.vm = this;
	}

	ngOnInit() {
		this.vm.user = this.session.getSession().user;
		this.vm.isValidPictureUrl = this.isValidPictureUrl;
		this.vm.getPictureUrl = this.getPictureUrl;
		this.vm.acceptOffer = this.acceptOffer;
		this.vm.declineOffer = this.declineOffer;
		this.vm.cancelOffer = this.cancelOffer;
		this.syncFromGroup();
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes['group'] || changes['chat']) {
			this.syncFromGroup();
		}
	}

	syncFromGroup() {
		this.vm.message = this.vm.group?.messages?.[0];
		this.loadMetadata();
	}

	loadMetadata() {
		var metadata: any = this.vm.message && this.vm.message.metadatas && this.vm.message.metadatas.find(function(item) {
			return item.type === 'BOOKING_OFFER';
		});
		if (metadata) {
			try {
				this.vm.metadata = JSON.parse(metadata.metadata);
				this.vm.metadata.type = metadata.type;
			} catch (e) {
				console.error(e);
			}
		}
	}

	isValidPictureUrl(pictureUrl) {
		return pictureUrl && pictureUrl.startsWith('http');
	}

	getPictureUrl() {
		return this.profilePictureService.getProfilePictureUrl(this.vm.metadata?.createdByUser);
	}

	hasInvoiceWarning() {
		return this.vm.metadata && this.vm.metadata.customerRemainingAmount > 0;
	}

	hasEmployerCoverage() {
		return this.vm.metadata && this.vm.metadata.employerCoveredAmount > 0;
	}

	hasNoEmployerCoverage() {
		return this.hasInvoiceWarning() && !this.hasEmployerCoverage();
	}

	formatAmount(amount: any) {
		if (amount === null || amount === undefined || amount === '') {
			return '';
		}
		return `${amount} ${this.vm.metadata?.serviceCurrency || ''}`.trim();
	}

	acceptOffer() {
		this.angularRoutingHelperService.setPath('/booking/offer/' + this.vm.metadata.id + '/checkout');
	}

	declineOffer() {
		this.setLoading(true);
		this.chatRestServices.declineBookingOffer({ bookingOfferId: this.vm.metadata.id },
			(res) => this.handleResult(res),
			(err) => this.handleError(err));
	}

	cancelOffer() {
		this.setLoading(true);
		this.chatRestServices.cancelBookingOffer({ bookingOfferId: this.vm.metadata.id },
			(res) => this.handleResult(res),
			(err) => this.handleError(err));
	}

	handleResult(res) {
		this.setLoading(false);
		if (res) {
			this.vm.group.messages[0] = res;
			this.syncFromGroup();
			this.vm.isValidPictureUrl = this.isValidPictureUrl;
			this.vm.getPictureUrl = this.getPictureUrl;
		}
		if (res?.chat?.id && !this.vm.chat.id) {
			this.vm.chat.id = res.chat.id;
		}
		this.angularBroadcastHelperService.rootBroadcast(this.config.getBroadcastConfig().Chat.CHAT_POST_EDITED, [res], this.vm.chat?.id || res?.chat?.id);
	}

	handleError(err) {
		const errorMessage: any = err?.error?.[0]?.message || err?.error?.errorCode;
		if (errorMessage === 'Overlapping') {
			this.toast.showAsync(this.angularFilterHelperService.translate('Booking.Errors.Overlapping_Time'), null, 6000, 'warning');
		} else {
			this.toast.showAsync(this.angularFilterHelperService.translate('Common.Failed'), null, 6000, 'error');
		}
		this.setLoading(false);
	}

	setLoading(loading: boolean) {
		this.vm.loading = loading;
	}

	@HostListener('window:resize')
	onResize() {
		this.isDesktop = window.innerWidth >= 768;
	}
}
